import { z } from "zod";
import { PatchApplicabilityReasonSchema } from "./patches.js";
/**
 * Portal-safe compilation / lifecycle phase.
 * READY = candidate revision is the active BusinessGraph head (not mere QA pass).
 */
export const ClientSafePatchCompilationPhaseSchema = z.enum([
    "NONE",
    "COMPILATION_PENDING",
    "QA_PENDING",
    "READY",
    "QA_BLOCKED",
    "CONTRADICTION_BLOCKED",
    "ACTIVATION_REJECTED",
    "FAILED",
    "SUPERSEDED",
]);
/** Portal-safe outcome envelope — never exposes runId / generationRunId / artifact internals. */
export const ClientSafePatchOutcomeV1Schema = z
    .object({
    schemaId: z.literal("client-safe-patch-outcome.v1"),
    attemptId: z.string().min(1),
    patchId: z.string().min(1),
    accepted: z.boolean(),
    compilationPhase: ClientSafePatchCompilationPhaseSchema,
    reasonCodes: z.array(PatchApplicabilityReasonSchema).optional(),
    /** Client-safe next-step message — never internal IDs. */
    clientMessage: z.string().min(1).optional(),
})
    .strict();
export const ClientSafePatchAttemptSummaryV1Schema = z
    .object({
    schemaId: z.literal("client-safe-patch-attempt-summary.v1"),
    attemptId: z.string().min(1),
    patchId: z.string().min(1),
    clientLinkId: z.string().min(1),
    status: z.enum(["REJECTED", "ACCEPTED"]),
    compilationPhase: ClientSafePatchCompilationPhaseSchema,
    reasonCodes: z.array(PatchApplicabilityReasonSchema).optional(),
    fromRevisionId: z.string().nullable(),
    toRevisionId: z.string().nullable(),
    createdAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=client-safe-patch-outcome.js.map